import script from "./AppInputSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInputSearch.vue?vue&type=script&setup=true&lang=js"

import "./AppInputSearch.vue?vue&type=style&index=0&id=5134d145&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5134d145"]])

export default __exports__